import { UNKNOWN_BARCODE_TYPE, ALL_VALID_BARCODE_FORMATS, BarcodeFormat } from "./validation";

/**
 * Quick helper for inserting prefix to provided barcode
 */
export function assignPrefix(barcode: string, prefix: string) {
  const isAlreadyContainingPrefix = barcode.slice(0, prefix.length) === prefix;
  if (isAlreadyContainingPrefix) return barcode;
  return prefix + barcode;
}

/**
 * Contains all our accepted barcode types
 * @param {string} code - The value to test against our accepted barcodes.
 * @returns {string} Return matching barcode type || UNKNOWN_BARCODE_TYPE
 */
export const detectBarcodeType = (code: string): BarcodeFormat => {
  for (const [format, regex] of Object.entries(ALL_VALID_BARCODE_FORMATS)) {
    if (regex.test(code)) {
      return format;
    }
  }
  return UNKNOWN_BARCODE_TYPE;
};

export const isValidBarcodeCharacter = (char: string) => /^[a-zA-Z0-9\-\.\$\/\+% ]$/.test(char);
